import { Button, CardContent, Collapse, Typography } from '@material-ui/core'
import cx from 'clsx'
import { useState } from 'react'

import { CategorySub, Maybe } from '@karakuri-web/faq-type'

interface QACategoryProps {
  id: string
  title?: Maybe<string>
  sub?: Maybe<readonly Maybe<CategorySub>[]>
  expand?: boolean
  level?: number
  onCategoryClick: (id: string) => void
  checker: (s: CategorySub) => boolean
  isSelected: (id: string) => boolean
  moveToCategoryPageOnCategoryClick?: boolean
}
export function QACategory({
  id,
  title,
  sub,
  expand,
  onCategoryClick,
  level = 0,
  checker,
  isSelected,
  moveToCategoryPageOnCategoryClick,
}: QACategoryProps) {
  const [expanded, setExpanded] = useState(expand)

  const handleExpandClick = () => {
    if (sub && sub.length > 0) {
      setExpanded(!expanded)
      if (moveToCategoryPageOnCategoryClick) {
        onCategoryClick(`category/${id}/`)
      }
    } else {
      onCategoryClick(`category/${id}/`)
    }
  }
  return (
    <>
      <CardContent className={cx('faq-category', { 'faq-category-level': level })}>
        <Button
          color={expanded ? 'default' : 'secondary'}
          variant="contained"
          onClick={handleExpandClick}
          aria-expanded={expanded}
          fullWidth
          className={cx('faq-category__button', {
            'faq-has-subcategory': sub && sub.length > 0,
            'faq-category__button--selected': isSelected(id),
          })}
          id={id}
        >
          <Typography className="faq-category__category" variant="h4" color="inherit">
            {title}
          </Typography>
        </Button>
      </CardContent>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {sub &&
          sub.map(v => {
            if (!v) {
              return null
            }
            const subCategoryId = v.id || ''
            const subs = v.sub
            if (subs?.length) {
              return (
                <QACategory
                  key={subCategoryId}
                  id={subCategoryId}
                  title={v.title}
                  sub={v.sub}
                  onCategoryClick={onCategoryClick}
                  level={level + 1}
                  expand={checker(v)}
                  checker={checker}
                  isSelected={isSelected}
                  moveToCategoryPageOnCategoryClick={moveToCategoryPageOnCategoryClick}
                />
              )
            }
            const handleCategoryClick = () => onCategoryClick(`category/${subCategoryId}/`)
            return (
              <Button
                fullWidth
                className={cx('faq-subcategory', 'faq-category__button', {
                  'faq-category__button--selected': isSelected(subCategoryId),
                })}
                key={subCategoryId}
                onClick={handleCategoryClick}
              >
                {v.title}
              </Button>
            )
          })}
      </Collapse>
    </>
  )
}
